import styled from "styled-components"
import Text from "../base/Text"
import Heading from "../base/Heading"

export const SectionText = styled(Text)`
  display: block;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.15em;
  font-weight: 700;
  color: rgb(255;148;147);
`

export const SectionHeading = styled(Heading)`
  text-align: center;
  font-size: [20px; 24px];
  font-weight: 400;
  color: #0f2137;
  letter-spaciong: -0.025em;
`
